import { array, boolean, defineAction, number, object, string } from '~/prix'
import monitorUserReportPreferences from './monitorUserReportPreferences.action.json'

const monitorUserReportPreferenceItem = object({
  destinationPath: string(),
  isFixed: boolean(),
  ordinalPosition: number(),
})

const monitorUserReportPreferencesDefinition = defineAction({
  ...monitorUserReportPreferences,
  input: object({
    preferences: array(monitorUserReportPreferenceItem).isOptional(),
  }),
  output: object({
    items: array(monitorUserReportPreferenceItem),
  }),
})

export default monitorUserReportPreferencesDefinition
